<template>
    <section class="section register-form">
        <div class="ingreso">
            <div class="card py-4">
                <div class="card-header-title is-size-3 pt-2 has-text-primary">
                    <h3>Ingresa tu correo</h3>
                </div>
                <div class="card-content">
                    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                        <div class="field mb-6">
                            <label class="label has-text-weight-bold" for="email">
                                Email
                            </label>
                            <Input
                                rules="required|email|max:250"
                                type="email"
                                ref="email"
                                label="Email"
                                v-model="email"
                                placeholder="correo@ejemplo.cl"
                                autocomplete="username"
                                name="email"
                            />
                        </div>
                        <div class="field mb-3 mt-3">
                            <button
                                class="button is-fullwidth is-primary"
                                :disabled="loading"
                                v-on:click.prevent="handleSubmit(submitForm)"
                            >
                                Solicitar cambio de clave
                            </button>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
            <p class="my-6 is-size-7">
                ¿Ya recordaste tu clave?
                <a class="ml-2 has-text-weight-semibold" v-on:click.prevent="$router.push('/')">
                    Volver al login
                </a>
            </p>
        </div>
    </section>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import Input from "@/components/inputs/Input";
import { recoveryEmail } from "@/api/security";
import { consoleHandlerError } from "@/utils/message";
import messages from "@/languages/es";

export default {
    name: "FormRecovery",
    components: {
        Input,
        ValidationObserver,
    },
    data: function() {
        return {
            errors: [],
            password_confirmation: "",
            email: "",
            publicPath: window.location.hostname,
            loading: false,
        };
    },
    methods: {
        submitForm() {
            this.loading = true;
            recoveryEmail(this.email)
                .then(() => {
                    this.$router.push("RecoveryConfirm");
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    consoleHandlerError({
                        error,
                        refFields: this.$refs,
                        customDefaultMessage: messages.recoveryPassword.doesNotExist,
                    });
                });
        },
    },
};
</script>
